import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface CreditCardPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const CreditCardPaymentSection: React.FC<CreditCardPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Código de Voucher"
        name="creditCardVoucher"
        iconKey="creditCard"
        type="text"
        placeholder="Ingrese el código del voucher"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default CreditCardPaymentSection;
